<template>
  <div v-if="data.contactGroup" class="cta-contact">
    <div class="grid-container">
      <div class="inner">
        <div class="imagewrapper">
          <Image
            v-if="data.contactGroup?.teamPhoto?.responsiveImage"
            :data="data.contactGroup?.teamPhoto.responsiveImage"
            object-fit="cover"
            class="image"
          />
        </div>
        <div class="content">
          <h2 v-if="data.contactGroup.title" class="title text-2xl">
            {{ data.contactGroup.title }}
          </h2>
          <StructuredText
            v-if="data.contactGroup.text"
            class="structured-text text text-lg"
            :data="data.contactGroup.text"
          />
        </div>
      </div>
    </div>
    <Stairs class="stairs" />
  </div>
</template>

<script setup lang="ts">
import { Image, StructuredText } from 'vue-datocms';
import type { CtaContactFragment } from '#gql';
import Stairs from '~/components/header-modules/svgs/Stairs.vue';

defineProps<{
  data: CtaContactFragment;
}>();
</script>

<style scoped lang="scss">
.cta-contact {
  background: var(--base-color-brand);
  color: var(--color-white);
  width: 100%;
  position: relative;

  @media (--xs), (--sm) {
    margin: var(--spacing-2xl) 0;
  }

  @media (--md), (--lg) {
    margin: var(--spacing-3xl) 0;
  }

  > .grid-container {
    @include grid-layout();

    & {
      padding: var(--site-inner-padding);
      width: 100%;
      max-width: var(--site-max-width);
      margin: auto;
    }

    > .inner {
      display: flex;
      grid-column: 1 / -1;

      @media (--xs) {
        padding: 3.13rem 0 12rem 0;
      }

      @media (--sm) {
        padding: 3.13rem 0 4.75rem 0;
      }

      @media (--xs), (--sm) {
        flex-direction: column;
        gap: var(--spacing-2xs);
      }

      @media (--md), (--lg) {
        display: grid;
        grid-template-columns: subgrid;
        padding: 4.48rem 0 5.77rem 0;
        align-items: center;
      }

      > .imagewrapper {
        @media (--xs), (--sm) {
          max-width: 21.5rem;
          aspect-ratio: 1 / 1;
        }

        @media (--md), (--lg) {
          grid-column: 1 / 9;
          width: 30rem;
          aspect-ratio: 1 / 1;
        }

        > .image {
          width: 100%;
          height: 100%;
        }
      }

      > .content {
        @media (--md), (--lg) {
          grid-column: 11 / -1;
        }

        > .title {
          margin-bottom: var(--spacing-3xs);
          color: var(--color-white);
        }
      }
    }
  }

  > .stairs {
    position: absolute;
    bottom: -1px;
    right: 0;
    aspect-ratio: 1 / 1;

    @media (--xs), (--md) {
      width: 10rem;
    }

    @media (--sm), (--lg) {
      width: 12rem;
    }

    @media (--lg-custom) {
      width: 25rem;
    }
  }
}
</style>
